import React from 'react';
import { FaEye, FaBullseye, FaStar } from 'react-icons/fa';

const About = () => {
  return (
    <div>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h2>About Fast Track College of Business, Healthcare and Technology</h2>
          <p>Shaping Futures Through Quality Education</p>
        </div>
      </section>

      <section className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-image">
              <img src="/about-details.jpg" alt="Our Story at Fast Track College" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }} />
            </div>
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                Fast Track College of Business, Healthcare and Technology was established with a vision to provide accessible, quality education 
                that empowers students to achieve their dreams faster. Since our inception, we have been 
                committed to academic excellence, innovation, and student success.
              </p>
              <p>
                Our institution has grown to become a leading educational institution, known for its 
                rigorous academic programs, experienced faculty, and state-of-the-art facilities. We 
                take pride in our diverse student community and our commitment to fostering an inclusive 
                learning environment.
              </p>
              <p>
                With a focus on practical learning and industry readiness, we prepare our students not 
                just for exams, but for life. Our graduates go on to excel in their chosen fields, 
                making significant contributions to society.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FaEye /></div>
              <h3>Vision</h3>
              <p>
                To be a leading institution of higher education that transforms lives through 
                accessible, innovative, and quality learning experiences.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaBullseye /></div>
              <h3>Mission</h3>
              <p>
                To provide comprehensive education that nurtures intellectual growth, critical thinking, 
                and ethical values, preparing students for global careers.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaStar /></div>
              <h3>Core Values</h3>
              <p>
                Excellence, Integrity, Innovation, Diversity, and Student-Centered Learning guide 
                everything we do at Fast Track College of Business, Healthcare and Technology.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about" style={{ background: 'var(--light-bg)' }}>
        <div className="container">
          <h2 className="section-title">Why Students Choose Us</h2>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '0.5rem' }}>Academic Excellence</h3>
              <p>Our programs are designed to meet the highest academic standards and industry requirements.</p>
            </div>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '0.5rem' }}>Experienced Faculty</h3>
              <p>Learn from professors who are experts in their fields with years of teaching and industry experience.</p>
            </div>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '0.5rem' }}>Modern Infrastructure</h3>
              <p>Study in a campus equipped with smart classrooms, laboratories, library, and sports facilities.</p>
            </div>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '0.5rem' }}>Affordable Education</h3>
              <p>Quality education at competitive fees with scholarship opportunities for deserving students.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
